let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('5jO3x') + "worker.7cefaee0.js" + "?" + Date.now();module.exports = workerURL(url, bundleURL.getOrigin(url), false);